import React from 'react'
import { CssBaseline } from '@material-ui/core'
import { CustomThemeProvider } from './styles'
import { DatabaseProvider } from './DatabaseContext'
import { AdDatabaseProvider } from './AdDatabaseContext'
import NavigationBar from './components/NavigationBar'
import HomePage from './components/HomePage'
import AdHomePage from './components/AdHomePage'

function App() {
  return (
    <div className='App'>
      <CustomThemeProvider>
        <CssBaseline />
        <AdDatabaseProvider>
          <NavigationBar />
          <AdHomePage />
        </AdDatabaseProvider>
      </CustomThemeProvider>
    </div>
  )
}

export default App
